import React from "react";
import HeroSection from "../common/HeroSection";
import Footer from "../common/Footer";
import Header from "../common/Header";
import ServicesSection from "./ServicesSection";
import "../../App.css";
import About from "./About";
import ContactUs from "./ContactUs";
import BottomBar from "../common/BottomBar";
import Awards from "./Awards";
import Product from "../home/Product"; // adjust path if needed
import ClientFeedbackSection from "./Client";

function Home() {
  return (
    <main
      style={{
        backgroundColor: "#fff",
      }}
    >
      <Header />
      <HeroSection />
      <About />
      <ServicesSection />
      <Awards />
      <ClientFeedbackSection />
      <ContactUs /> 
      <Footer />
      <BottomBar />
      <div
        className="whatsAppIcon"
        style={{
          position: "fixed",
          left: "10px",
          zIndex: "999999999",
          top: "auto",
          bottom: "7px",
          width: "60px",
        }}
      >
        <a
          target="_blank"
          href="https://wa.me/02687-248881"
          aria-label="Let's Connect"
        >
          <img
            src="/assets/whatsapp.webp"
            alt="whatsapp"
            width={60}
            height={60}
          />
        </a>
      </div>
    </main>
  );
}

export default Home;
